import { motion } from "framer-motion";
import QuoteModal from "@/components/QuoteModal";

const ways = [
  {
    num: "01",
    title: "Supply",
    accent: "Only",
    desc: "We hand-select and ship premium hardwood, engineered planks, and luxury vinyl from our curated catalog  or we'll commission a bespoke floor from our Custom Line, delivered anywhere in Michigan.",
    cta: "phone" as const,
  },
  {
    num: "02",
    title: "Supply +",
    accent: "Install",
    desc: "The complete experience. We consult on species and specification, engineer the subfloor, and install to strict NWFA standards  so you never have to coordinate between separate trades.",
    cta: "form" as const,
  },
  {
    num: "03",
    title: "Service",
    accent: "Only",
    desc: "Already have floors that need attention? We offer dust-controlled refinishing, independent NWFA inspections for disputes, and precision subfloor correction.",
    cta: "form" as const,
  },
];

const HowWeWork = () => (
  <section className="bg-neutral-50 py-14 md:py-20 lg:py-28">
    <div className="max-w-[1200px] mx-auto px-5 md:px-12 text-center mb-10 md:mb-14">
      <p className="text-[11px] font-semibold tracking-[.18em] uppercase text-[hsl(38,65%,35%)] mb-3">
        How We Work
      </p>
      <h2 className="font-display text-[clamp(28px,5vw,56px)] font-semibold text-foreground leading-[1.1] mb-4">
        Three ways to work<br />
        with <em className="italic font-normal text-[hsl(38,65%,35%)]">1 Wood Floors.</em>
      </h2>
      <p className="text-[14px] md:text-[17px] font-light text-neutral-600 leading-relaxed max-w-[600px] mx-auto">
        Whether you need materials only, the full white glove experience, or expert service on existing floors  we tailor the partnership to you.
      </p>
    </div>

    <div className="max-w-[1200px] mx-auto px-5 md:px-12 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
      {ways.map((w, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: i * 0.08 }}
          className="relative bg-background border border-border rounded-[20px] p-7 md:p-10 flex flex-col justify-between min-h-[260px] md:min-h-[340px]"
        >
          <span className="absolute top-6 right-6 md:top-8 md:right-8 font-display text-[48px] md:text-[72px] font-bold text-foreground/[.06] leading-none pointer-events-none">
            {w.num}
          </span>

          <div>
            <h3 className="font-display text-[22px] md:text-[26px] font-semibold text-foreground tracking-tight mb-2 md:mb-3 mt-8 md:mt-10">
              {w.title} <em className="italic font-normal text-primary">{w.accent}</em>
            </h3>
            <p className="text-[13px] md:text-sm font-normal text-foreground/75 leading-relaxed">
              {w.desc}
            </p>
          </div>

          {w.cta === "phone" ? (
            <a
              href="tel:2483258853"
              className="text-primary text-sm font-medium mt-4 md:mt-6 inline-flex items-center gap-1.5 hover:gap-2.5 transition-all"
            >
              📞 Call (248) 325-8853
            </a>
          ) : (
            <QuoteModal
              trigger={
                <button className="text-primary text-sm font-medium mt-4 md:mt-6 inline-flex items-center gap-1.5 hover:gap-2.5 transition-all text-left">
                  Schedule a Consultation <span>→</span>
                </button>
              }
            />
          )}
        </motion.div>
      ))}
    </div>
  </section>
);

export default HowWeWork;
